import type {
  Return,
  ReturnListResponse,
  CreateReturnRequest,
  UpdateReturnRequest,
  ReturnStatus,
  ReturnFilter,
} from '../types/returns';
import { get, post, put, patch, del, buildUrl } from './apiClient';

const API_BASE = '/api/v1/returns';

// ============================================================================
// Return CRUD
// ============================================================================

export async function createReturn(request: CreateReturnRequest): Promise<Return> {
  return post<Return>(API_BASE, request);
}

export async function getReturn(id: string): Promise<Return> {
  return get<Return>(`${API_BASE}/${id}`);
}

export async function listReturns(filter?: ReturnFilter): Promise<ReturnListResponse> {
  return get<ReturnListResponse>(buildUrl(API_BASE, filter as Record<string, unknown> | undefined));
}

export async function updateReturn(id: string, request: UpdateReturnRequest): Promise<Return> {
  return put<Return>(`${API_BASE}/${id}`, request);
}

// ============================================================================
// Status Management
// ============================================================================

export async function updateReturnStatus(id: string, status: ReturnStatus): Promise<void> {
  await patch(`${API_BASE}/${id}/status`, { status });
}

// Complete the return and process refund
export async function completeReturn(id: string): Promise<void> {
  await post(`${API_BASE}/${id}/complete`);
}

// ============================================================================
// Delete
// ============================================================================

export async function deleteReturn(id: string): Promise<void> {
  await del(`${API_BASE}/${id}`);
}
